var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagramW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.209,
    height: 17.212,
    viewBox: "0 0 17.209 17.212",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(-1148.05 -18.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M14.563,1.6a6.341,6.341,0,0,0-.4-2.1,4.241,4.241,0,0,0-1.008-1.546A4.315,4.315,0,0,0,11.61-3.044a6.373,6.373,0,0,0-2.1-.4C8.606-3.49,8.3-3.5,6-3.5c-2.283,0-2.586.01-3.5.05a6.342,6.342,0,0,0-2.1.4A4.241,4.241,0,0,0-1.142-2.04,4.318,4.318,0,0,0-2.147-.5a6.374,6.374,0,0,0-.4,2.1c-.043.908-.053,1.209-.053,3.508,0,2.283.01,2.586.05,3.5a6.341,6.341,0,0,0,.4,2.1,4.279,4.279,0,0,0,1.008,1.546A4.318,4.318,0,0,0,.4,13.26a6.376,6.376,0,0,0,2.1.4c.915.04,1.218.05,3.5.05s2.59-.01,3.5-.05a6.342,6.342,0,0,0,2.1-.4,4.468,4.468,0,0,0,2.551-2.551,6.378,6.378,0,0,0,.4-2.1c.04-.919.05-1.222.05-3.5C14.606,2.8,14.6,2.505,14.563,1.6ZM6.008,11.954c-2.231,0-2.527-.009-3.425-.05a4.561,4.561,0,0,1-1.54-.285,2.515,2.515,0,0,1-.934-.608A2.513,2.513,0,0,1-.5,10.078,4.56,4.56,0,0,1-.782,8.539c-.041-.919-.05-1.192-.05-3.425s.009-2.527.05-3.425A4.561,4.561,0,0,1-.5.149,2.486,2.486,0,0,1,.114-.785a2.509,2.509,0,0,1,.934-.606,4.562,4.562,0,0,1,1.539-.284c.881-.039,1.117-.05,3.424-.05,2.227,0,2.524.01,3.425.05a4.563,4.563,0,0,1,1.54.285,2.513,2.513,0,0,1,.934.608,2.513,2.513,0,0,1,.606.934A4.56,4.56,0,0,1,12.8,1.69c.039.88.05,1.117.05,3.425s-.011,2.541-.05,3.421a4.559,4.559,0,0,1-.284,1.539,2.7,2.7,0,0,1-1.546,1.546,4.558,4.558,0,0,1-1.539.284C8.514,11.945,8.241,11.954,6.008,11.954Z",
    transform: "translate(1150.653 21.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M126.157,120.781a4.478,4.478,0,1,0,4.478,4.478A4.483,4.483,0,0,0,126.157,120.781Zm0,7.191a2.713,2.713,0,1,1,2.713-2.713A2.716,2.716,0,0,1,126.157,127.972Z",
    transform: "translate(1030.5 -98.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M361.03,86.081a1.135,1.135,0,1,0-1.135,1.135A1.136,1.136,0,0,0,361.03,86.081Z",
    transform: "translate(801.296 -63.881)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramW);
export default __webpack_public_path__ + "static/media/Instagram-W.90928627061a4e6e94620babf396e5e7.svg";
export { ForwardRef as ReactComponent };